import * as React from "react";
import PropTypes from "prop-types";
import prefixStyles from "nx-components/utils/prefixStyles";
import { AppBarIconWrapper } from "nx-components/AppBar";
import Popover from "nx-components/Popover";
import { iconFromAPIName, IconHomeMode } from "nx-components/Icons";
import AppState from "nexia_mobile/models/app_state";
import BackboneListener from "nexia_mobile/components/BackboneListener";
import connect from "nexia_mobile/flux_like/store/connect";
import ModeList from "./ModeList";

const styles = {
  listWrapper: prefixStyles({
    display: "flex",
    position: "relative",
    right: "0.25em", // don't align the box all the way on the right edge of the screen
    width: "14em",
    maxWidth: "75vw",
    maxHeight: "70vh",
    backgroundColor: "white",
    borderRadius: 4,
    overflow: "hidden", // so that content gets cut by the border radius
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.4)",
  }),
};

class ModeSelector extends React.Component {
  static propTypes = {
    appState: PropTypes.instanceOf(AppState),
  };

  state = {
    popoverOpen: false,
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  _closePopover = () => {
    if (this._isMounted) {
      this.setState({ popoverOpen: false });
    }
  };

  render() {
    const { appState } = this.props;

    return (
      <BackboneListener listenTo={appState} events={["change:currentLocation"]}>
        {() => {
          if (appState == null) {
            return null;
          }

          return (
            <BackboneListener
              listenTo={appState.currentLocation}
              events={["change:modes"]}
            >
              {() => {
                if (appState.currentLocation == null) {
                  return null;
                }

                const modesCollection = appState.currentLocation.get("modes");

                if (modesCollection == null) {
                  return null;
                }

                return (
                  <BackboneListener
                    listenTo={modesCollection}
                    events={[
                      "add",
                      "remove",
                      "reset",
                      "sort",
                      "sync",
                      "change",
                    ]}
                    debounceRender
                  >
                    {() => {
                      const { popoverOpen } = this.state;

                      let modeIcon;
                      const currentMode = modesCollection.getActiveMode();
                      if (currentMode != null) {
                        modeIcon = currentMode.get("icon");
                      }

                      const ModeIconClass =
                        (modeIcon && iconFromAPIName(modeIcon)) || IconHomeMode;

                      return (
                        <AppBarIconWrapper
                          name="ModeSelector"
                          onTap={() => this.setState({ popoverOpen: true })}
                          innerRef={(el) => (this._target = el)}
                          aria-label="House Mode"
                        >
                          <ModeIconClass style={{ verticalAlign: "" }} />
                          <Popover
                            open={popoverOpen}
                            arrowPosition="topRight"
                            onRequestClose={() =>
                              this.setState({ popoverOpen: false })
                            }
                            getTargetRect={() => {
                              if (this._target) {
                                return this._target.getBoundingClientRect();
                              } else {
                                return null;
                              }
                            }}
                          >
                            <div style={styles.listWrapper}>
                              <ModeList
                                modesCollection={modesCollection}
                                onFinished={this._closePopover}
                              />
                            </div>
                          </Popover>
                        </AppBarIconWrapper>
                      );
                    }}
                  </BackboneListener>
                );
              }}
            </BackboneListener>
          );
        }}
      </BackboneListener>
    );
  }
}

export default connect(
  {
    appState: "appState",
  },
  ModeSelector
);



// WEBPACK FOOTER //
// ./src/components/TopBar/ModeSelector/index.jsx